import React from 'react';
import { BrowserRouter, Link, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { MatchProvider, useMatch } from './game/MatchContext';
import { ErrorBoundary, Shell } from './components/Shell';
import { Button, Notice, PageHeading } from './components/UI';
import Setup from './pages/Setup';
import Placement from './pages/Placement';
import Battle from './pages/Battle';
import Results from './pages/Results';
import Analysis from './pages/Analysis';

function MatchGate({ children }) {
  const { game, loading, error, sessionId, refresh, busy, begin, settings } = useMatch();
  const navigate = useNavigate();
  if (loading) return <div aria-busy="true"><PageHeading title="Loading match…" /><p role="status">Fetching the saved game from the server.</p></div>;
  if (!game) return <div><PageHeading title={sessionId ? 'Match unavailable' : 'No match to display'} />{error ? <Notice error>{error}</Notice> : <p>Start a game to use this screen.</p>}<div className="inline-actions">{sessionId && <Button disabled={busy} onClick={refresh}>{busy ? 'Checking…' : 'Try again'}</Button>}<Button primary onClick={() => { begin(settings); navigate('/'); }}>New game</Button></div></div>;
  return children;
}
function PlacementRoute() { const { loading } = useMatch(); return loading ? <div aria-busy="true"><PageHeading title="Loading match…" /><p role="status">Fetching the saved game.</p></div> : <Placement />; }
function NotFound() { return <div><PageHeading title="Page not found" subtitle="This address does not lead to a game screen." /><Link to="/">Return to Quantum Battleship</Link></div>; }
export default function App() {
  return <ErrorBoundary><BrowserRouter><MatchProvider><Shell><Routes>
    <Route path="/" element={<Setup />} /><Route path="/level-selection" element={<Navigate to="/" replace />} /><Route path="/login" element={<Navigate to="/" replace />} />
    <Route path="/ship-placement" element={<PlacementRoute />} />
    <Route path="/battle-interface" element={<MatchGate><Battle /></MatchGate>} />
    <Route path="/game-results" element={<MatchGate><Results /></MatchGate>} />
    <Route path="/quantum-state-viewer" element={<MatchGate><Analysis /></MatchGate>} />
    <Route path="*" element={<NotFound />} />
  </Routes></Shell></MatchProvider></BrowserRouter></ErrorBoundary>;
}
